/* global angular */

(function() {
    "use strict";

    var app = angular.module('app');

    app.controller('NewsletterCtrl', ['$scope', 'State', 'api', 'gtm', function ($scope, State, api, gtm) {

        var state = new State();
        var model = {};        

        function submit() {            
            if (state.busy()) {                
                api.action.newsletter(model).then(function (response) {                    
                    if (response.data.status) {
                        state.success();
                        gtm.push({ event: 'Newsletter' });
                    } else {
                        state.error({ message: response.data.HTML });
                    }
                }, function (error) {
                    state.error(error);
                });
            }
        }

        state.ready();

        $scope.state = state;
        $scope.model = model;
        $scope.submit = submit;

    }]);
    
}());